interface GooglePlayIconProps {
  className?: string
  width?: number
  height?: number
  fill?: string
}

export default function GooglePlayIcon(props: GooglePlayIconProps) {
  const { className, width = 20, height = 20 } = props

  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        fill="#00d7fe"
        d="M3.2 2.6A2.4 2.4 0 0 0 3 3.63v16.74c0 .42.07.76.21 1.04L12.72 12 3.2 2.6Z"
      />
      <path
        fill="#ffce00"
        d="m15.86 8.88-3.14 3.11 3.19 3.15 3.66-2.05c1.04-.58 1.04-1.53 0-2.11l-3.71-2.1Z"
      />
      <path fill="#ff3a44" d="m3.21 21.41 12.7-6.27-3.19-3.15-9.51 9.42Z" />
      <path fill="#00f076" d="m3.2 2.59 9.52 9.4 3.14-3.11L3.2 2.59Z" />
    </svg>
  )
}
